/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
// eslint-disable-next-line import/no-unresolved

const MobilePpcCard = ({ date, name, metrics }) => {
  const [fullView, setFullview] = React.useState(false);
  const useStyles = makeStyles(() => ({
    mobileCard: {
      background: 'white',
      borderRadius: '16px',
      padding: 15,
      margin: 10,
      border: '3px white solid',
    },
    flexLine: {
      display: 'flex',
      alignItems: 'center',
      margin: '10px 0',
      width: '100%',
    },
    flexLineDefault: {
      display: 'flex',
      alignItems: 'center',
    },
  }));

  const handleClick = () => {
    setFullview(!fullView);
  };

  const classes = useStyles();
  return (
    <>
      <div className={classes.mobileCard} onClick={handleClick} aria-label="default box">
        {fullView ? (
          <>
            <div className={classes.flexLine}>
              <div style={{ width: '20%', userSelect: 'none' }}>{date}</div>
              <div style={{ width: '80%', userSelect: 'none' }}>{name}</div>
            </div>
            <div
              style={{ background: '#00B4E0', height: '1px', width: '100%', margin: '10px 0' }}
            />
            <div>
              <div style={{ width: '100%', userSelect: 'none' }} data-testid="costPpcCard-testid">
                Cost: ${`${Number(metrics['metrics.cost_micros']).toFixed(2)}`}
              </div>
              <div style={{ width: '100%', userSelect: 'none' }}>
                Total Conversions: {`${metrics['metrics.conversions']}`}
              </div>
              <div style={{ width: '100%', userSelect: 'none' }}>
                Cost/Conversions: ${`${Number(metrics['metrics.cost_per_conversions']).toFixed(2)}`}
              </div>
              <div style={{ width: '100%', userSelect: 'none' }}>
                Impressions: {`${metrics['metrics.impressions']}`}
              </div>
              <div style={{ width: '100%', userSelect: 'none' }}>
                Clicks: {`${metrics['metrics.clicks']}`}
              </div>
              <div style={{ width: '100%', userSelect: 'none' }}>
                Search Impression Share:{' '}
                {metrics['metrics.search_impression_share']
                  ? `${Number(metrics['metrics.search_impression_share']).toFixed(2)}%`
                  : '-'}
              </div>
            </div>
          </>
        ) : (
          <div className={classes.flexLineDefault}>
            <div className={classes.flexLine}>
              <div style={{ width: '25%', userSelect: 'none' }}>{date}</div>
              <div style={{ width: '75%', userSelect: 'none' }}>{name}</div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default MobilePpcCard;
